import {BackendApi} from '@/services/backend_api'

export default {
  byParkQuizUuid (parkQuizUuid) {
    return BackendApi.getClient().get(`/quiz-evaluations/?parkQuiz=${parkQuizUuid}`)
      .then(response => { return response })
      .catch(e => { throw e })
  },
  post (parkQuizUuid, approvedAxis = [], disapprovedAxis = []) {
    return BackendApi.getClient().post(`/quiz-evaluations/`, { parkQuizUuid, approvedAxis, disapprovedAxis })
      .then(response => { return response })
      .catch(e => { throw e })
  },
  put (id, parkQuizUuid, approvedAxis = [], disapprovedAxis = [], isParkQuizApproved = null) {
    return BackendApi.getClient().put(`/quiz-evaluations/${id}`, { parkQuizUuid, approvedAxis, disapprovedAxis, isParkQuizApproved })
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/quiz_evaluation.js